import { render, staticRenderFns } from "./PackedOrders.vue?vue&type=template&id=5320d4d9&"
import script from "./PackedOrders.vue?vue&type=script&lang=js&"
export * from "./PackedOrders.vue?vue&type=script&lang=js&"
import style0 from "./PackedOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports